import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setAuthFromGoogle } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login");
      return;
    }
    const session_id = m[1];

    (async () => {
      try {
        const r = await api.post("/auth/google-session", { session_id });
        setAuthFromGoogle(r.data.user);
        toast.success(`ကြိုဆိုပါတယ် ${r.data.user.name}!`);
        navigate("/dashboard", { replace: true, state: { user: r.data.user } });
      } catch (e) {
        console.error("Google session exchange failed:", e);
        toast.error("Google ဝင်ရောက်ခြင်း မအောင်မြင်ပါ");
        navigate("/login");
      }
    })();
    // hasProcessed.current guard prevents re-entry; navigate/setAuthFromGoogle are stable.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-[60vh] grid place-items-center text-zinc-500">
      ဝင်ရောက်နေသည်…
    </div>
  );
}
